module.exports = __webpack_public_path__ + "static/media/wifiqube-3.3ae75a6a.jpg";